<template>
    <div class="">

        <div class="panel-body">
            <div class="form-group">
                <label for="select-series">
                    What topic are you interested in? Determine a time series variable first (pattern), and let Massive
                    Data Analysis do the correlation work on all ATSNOW time series/databases.
                </label>
                <div class="input-group">
                    <input
                            v-model="q"
                            v-on:keyup="keyup($event)"
                            name="q"
                            id="select-series"
                            class="form-control"
                            type="search"
                            autocomplete="off"
                            v-el:qfield
                            ref="qfield"
                            v-on:submit.prevent="submit"
                    >
                    <span style="cursor: pointer" class="input-group-addon" v-on:click="submit">
                        <i class="fa fa-search"></i>
                    </span>

                    <div
                            class="autocomplete"
                            v-if="suggest.length > 0"
                    >
                        <ul class="list-unstyled">
                            <li
                                    v-bind:class="{'active': pos == e.key}"
                                    v-on:mouseover="pos = e.key"
                                    v-on:click="add(e.item)"
                                    v-for="e in result"
                            >{{ e.item }}
                            </li>
                        </ul>
                    </div>
                </div>

                <p class="help-block">E.g. &quot;GDP Italy&quot;</p>

            </div>

            <div>

                <div v-show="loading">
                    loading <i class="fa fa-spinner fa-spin"></i>
                </div>

                <div v-show="series.length > 0">
                    <p style="font-weight:bold">
                        Select a time series.
                    </p>

                    <div v-for="s in series" class="search">
                        <div class="panel panel-default clickable" v-on:click="select(s.id)"
                             v-bind:class="{'panel-primary': s.id == id}">
                            <div class="panel-heading">
                                <h3 class="panel-title">
                                    {{ s.indicator.translations.en }}
                                </h3>
                            </div>
                            <div class="panel-body">
                                <p>
                            <span>
                                ({{ s.date_min }} - {{ s.date_max }})
                            </span><br/>
                                    {{ s.headline }}
                                </p>

                                <div v-if="s.id === id">

                                    <data-chart></data-chart>

                                    <div class="btn-group-justified btn-group">
                                        <a v-bind:href="link" class="btn btn-primary btn-group">
                                            Continue <i class="fa fa-chevron-right"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </div>
        </div>

    </div>
</template>

<script>

    export default {
        props: ['preSelect'],

        data: function () {
            return {
                ac: [],
                pos: -1,
                q: '',
                series: [],
                loading: false,
                id: null,
                storage: storage,
                current: null,
            };
        },

        computed: {
            title: function () {
                return this.storage.title;
            },

            pattern: function () {
                return this.storage.pattern;
            },

            suggest: function () {
                if (this.loading) {
                    return [];
                }

                return this.ac;
            },

            result: function () {
                return this.ac.map(function (item, key) {
                    return {
                        item: item,
                        key: key
                    };
                })
            },

            link: function () {
                if (this.current === null) {
                    return '';
                }

                return '/regression/' + this.current.identifier;
            }
        },

        mounted: function () {
            if (this.preSelect.length > 0) {
                this.selectNext(this.preSelect);
            }
        },

        methods: {
            selectNext: function (series) {
                window.http.get('/api/v1/series/' + series).then((response) => {
                    this.storage.updateTitle(response.data.series.description.en);
                    this.storage.updatePattern(response.data.series.observations.map(function (row) {
                        return row.time.substr(0, 4) + ',' + row.value;
                    }).join("\n"));
                    this.$root.$emit('nextStep', 'input_pattern');
                });

                this.id = series;
            },

            next: function () {
                this.$root.$emit('nextStep', 'review');
            },

            edit: function () {
                this.$root.$emit('nextStep', 'input_pattern');
            },

            select: function (id) {
                window.http.get('/api/v2/series/' + id).then((response) => {
                    this.current = response.data.series[0];
                    this.storage.updateTitle(response.data.series[0].description.en);
                    this.storage.updatePattern(response.data.series[0].observations.map(function (row) {
                        return row.time.substr(0, 4) + ',' + row.value;
                    }).join("\n"));
                });

                this.id = id;
            },

            keyup: function (event) {
                if (event.code === 'ArrowUp') {
                    return this.up();
                }

                if (event.code === 'ArrowDown') {
                    return this.down();
                }

                if (event.code === 'Enter') {
                    return this.submit();
                }

                this.update();
            },

            update: function () {
                this.pos = -1;

                if (this.q.length < 1) {
                    this.ac = [];
                    return;
                }

                let that = this;

                window.http.get('/api/v1/indicators/suggest/' + this.q).then((response) => {
                    that.ac = response.data;
                });
            },
            down: function () {
                this.pos++;
                this.q = this.ac[this.pos];
            },
            up: function () {
                this.pos--;
                this.q = this.ac[this.pos];
            },
            add: function (text) {
                this.q = text;
                this.$refs.qfield.focus();
                let that = this;
                Vue.nextTick(function () {
                    that.submit();
                });
            },
            submit: function () {
                // ignore empty queries.
                if (this.q.length === 0) {
                    return;
                }

                this.loading = true;
                this.series = [];
                this.ac = []; // clear autocomplete!
                window.http.get('/api/v1/series/search?query=' + this.q).then((response) => {
                    this.loading = false;
                    this.series = response.data.series;
                });
            },
        },
    }

</script>
